import { render, staticRenderFns } from "./ItemoptionsShared.vue?vue&type=template&id=5a6e5144"
import script from "./ItemoptionsShared.vue?vue&type=script&lang=js"
export * from "./ItemoptionsShared.vue?vue&type=script&lang=js"
import style0 from "./ItemoptionsShared.vue?vue&type=style&index=0&id=5a6e5144&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports